import Boto from 'components/corporatiu/Boto';
import styles from './notfound.module.scss';

export default function NotFound(props) {
    const { code, text = '' } = props;

    return (
        <div className={styles.notfound} data-testid={`error-${code}`}>
            <h3 className={styles.code}>{code}</h3>
            <p className={styles.text}>{text}</p>
            <Boto tag='a' estil='portal100' text='VES A 3CAT' className={styles.boto} fons='fosc' route={{ href: '/3cat' }} />
        </div>
    );
}
